import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material/dialog';

import { GerenciarPerfisUsuariosApiService } from '../../../services/gerenciar-perfis-usuarios-api.service';
import { MessageService } from '@services/message.service';
import { Papel } from '../../../models/papel';

@Component({
  selector: 'app-criar-papel-dialog',
  standalone: false,
  templateUrl: './criar-papel-dialog.component.html',
  styleUrl: './criar-papel-dialog.component.scss',
})
export class CriarPapelDialogComponent {

  nome: string = '';
  descricao: string = '';
  salvando = false;

  constructor(
    private gerenciarPerfisUsuariosApiService: GerenciarPerfisUsuariosApiService,
    private messageService: MessageService,
    private dialogRef: MatDialogRef<CriarPapelDialogComponent>,
  ) { }

  public salvarClick(): void {
    if (!this.nome?.trim()) {
      this.messageService.showToastWarning('O nome do papel não pode ser vazio.');
      return;
    }

    this.salvando = true;
    this.gerenciarPerfisUsuariosApiService.criarPapel(this.nome.trim(), this.descricao.trim()).subscribe({
      next: (papel: Papel) => {
        this.messageService.showToastSuccess(`Papel "${papel.nome}" criado com sucesso.`);
        this.dialogRef.close(papel);
      },
      error: () => {
        this.salvando = false;
      },
    });
  }
}
